import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export default function HighlightCards({ classes, data, hasScroll = true }) {
  const { title, desc, list, moreInfo } = data;

  const Title = () => (
    <article className="container lg:maxw-xls block--align-center lg:text-center md:text-center">
      <h2 className="text-lg md:mb-0">{title}</h2>
      {desc != undefined ? (
        <p
          className="lg:mt-3 md:mt-2"
          dangerouslySetInnerHTML={{ __html: desc }}
        />
      ) : (
        ""
      )}
    </article>
  );

  const List = () => {
    let theClasses;
    let theCount = list.length;
    if (theCount === 3) {
      theClasses = "has-three-col";
    }
    if (theCount === 4) {
      theClasses = "has-four-col";
    }

    return (
      <div
        className={`container card--default scroll-container lg:mt-10 md:mb-2 ${theClasses}`}
      >
        {list.map((item, count) => {
          return (
            <a
              className="btn-outline md:mb-0 md:mt-5 pt-3 pb-4 px-3 text-left bg:hover-white"
              href={item.href}
              key={count}
            >
              <div className={`${item.hasOwnProperty("logo") ? "fx" : ""}`}>
                {item.hasOwnProperty("logo") && (
                  <i dangerouslySetInnerHTML={{ __html: item.logo }}></i>
                )}
                <h3
                  className={`lg:mb-3 text-brandcolor ${
                    item.hasOwnProperty("logo") ? "ml-1" : ""
                  }`}
                >
                  {item.heading}
                </h3>
              </div>
              <p className="md:mt-1.5">{item.desc}</p>
              <style jsx>
                {`
                  .fx {
                    display: flex;
                  }
                  @media (max-width: ${viewport.tablet.sm}) {
                    a {
                      background-color: ${colors.primitive.white.default};
                      box-shadow: 0 1px 2px 0 rgba(48, 58, 71, 0.2),
                        0 1px 3px 0 rgba(48, 58, 71, 0.1);
                      border: none;
                    }
                    a:hover {
                      box-shadow: 0 1px 2px 0 rgba(48, 58, 71, 0.2),
                        0 1px 3px 0 rgba(48, 58, 71, 0.1);
                    }
                  }
                `}
              </style>
            </a>
          );
        })}
      </div>
    );
  };
  return (
    <section className={`bg-light ${classes.length > 0 ? classes : ""}`}>
      <Title />
      <List />
      <div
        className="text-center lg:mt-5 text-sm mx-4"
        dangerouslySetInnerHTML={{ __html: moreInfo }}
      />
    </section>
  );
}
